export default (param: string) =>
  param
    ? param
        .replace(/[^a-z0-9éàèùâêîôûçëïü\-\s]/gi, "")
        .replace(/\s/gi, "-")
        .replace(/-+/gi, "-")
        .toLowerCase()
    : "";
